import React, { Component } from 'react';
import { OffCanvasItem } from '../../components/offCanvasNavigation';
import { getPublicTree } from '../../services/help';

/**
 * Item "Preguntas frecuentes": aparece si townhall-api tiene la base de conocimiento habilitada y con algo publicado
 * (con el flag apagado el endpoint da 404 y el item no se muestra).
 */
export class HelpNavItem extends Component {
  state = { available: false };

  componentDidMount() {
    this.mounted = true;
    getPublicTree().then(tree => {
      if (this.mounted) {
        this.setState({
          available: !!(tree && tree.categories && tree.categories.length)
        });
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    if (!this.state.available) {
      return null;
    }
    const { currentPath } = this.props;
    return (
      <OffCanvasItem
        label="Preguntas frecuentes"
        icon="help"
        linkTo="/help"
        isActive={currentPath === '/help' || currentPath.startsWith('/help/')}
      />
    );
  }
}

export default HelpNavItem;
